<template>
    <div class="page course-detail">
        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <video
            id="my-video"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="none"
            x5-playsinline=""
            webkit-playsinline=""
            playsinline=""
            :poster="course.cover_img"
            x-webkit-airplay="true"
        ></video>

        <div class="course-detail-header">
            <div class="header-title">{{ course.title }}</div>
            <div class="header-view">
                <div class="header-time-long">{{ course.created_at }}|{{ Duration }}分钟</div>
                <div class="header-view-count">
                    <div class="header-view-count-text">{{ course.view_count }}人学习</div>
                    <div class="header-view-count-images">
                        <img :src="item" alt="" v-for="(item, index) in course.last_study_user_avatar" :key="index" />
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="course-detail-content">
            <div class="rich_media_inner" v-html="course.content"></div>
        </div>

        <div class="comment">
            <div class="comment-title">评论</div>
            <div class="comment-section" v-for="item in comment" :key="item.id">
                <div class="comment-section-photo">
                    <img :src="item.avatar" alt="" />
                </div>
                <div class="comment-section-content">
                    <div class="comment-section-content-author" @click="reComment(item)">
                        {{ item.nickname }}
                    </div>
                    <div class="comment-section-content-detail" @click="reComment(item)">
                        {{ item.content }}
                    </div>
                    <div class="comment-section-content-bottom">
                        <div class="comment-section-content-time">
                            {{ item.created_at }}
                        </div>
                        <div class="comment-section-content-point" @click="pointLikeComment(item)">
                            <span v-if="item.isLike"><van-icon name="/static/img/course/icon_course_like_on.svg"/></span>
                            <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg"/></span>
                            {{ item.like_count == 0 ? '赞' : item.like_count }}
                        </div>
                        <div class="clear"></div>
                        <div class="comment-section-content-children" v-if="item.children != null && item.children.length > 0">
                            <div v-for="val in item.children">
                                <span @click="reCommentChild(val)">{{ val.name }}</span
                                ><span style="color: #404040" v-if="val.reply_name != ''"> 回复 </span
                                ><span @click="reCommentChild(val)">{{ val.reply_name }}</span
                                >：{{ val.content }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="clear"></div>
        </div>

        <div class="course-detail-footer" v-if="tab != 2" style="padding-bottom: env(safe-area-inset-bottom);">
            <img @click="openShareData" class="course-detail-share-button" src="/static/img/btn_share.svg" alt="" />

            <div class="course-detail-column-box" v-if="course.parent != null">
                <van-cell title-class="control-title" is-link url="/course_list" :to="'/video-column/' + course.parent.id">
                    <div slot="title"><span class="course-detail-column-box-left">所属专栏</span>{{ course.parent.title }}</div>
                </van-cell>
            </div>

            <div class="course-detail-footer-box">
                <div :class="'course-detail-footer-left ' + (comment_text != '' ? 'comment_in' : '')">
                    <van-field round left-icon="/static/img/course/icon_course_text.svg" v-model="comment_text" :placeholder="comment_placeholder">
                    </van-field>
                </div>
                <div :class="'course-detail-footer-right ' + (comment_text != '' ? 'comment_in' : '')">
                    <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
                        <van-grid-item icon="/static/img/course/icon_course_comment.svg" text="评论" @click="goComment" :badge="comment.length" />
                        <van-grid-item
                            v-if="course.isLike"
                            icon="/static/two/icon_course_like_on.svg"
                            @click="pointLike()"
                            text="已点赞"
                            :badge="course.like_count"
                        ></van-grid-item>
                        <van-grid-item
                            v-else
                            icon="/static/two/icon_course_like_off.svg"
                            @click="pointLike()"
                            text="点赞"
                            :badge="course.like_count"
                        ></van-grid-item>
                        <van-grid-item
                            @click="favorite()"
                            v-if="course.isFavorite"
                            icon="/static/img/course/icon_course_favorite_on_20.svg"
                            text="已收藏"
                        />
                        <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏" />
                    </van-grid>
                    <div class="course-detail-footer-right-btn" v-else>
                        <van-button type="danger" size="medium" @click="createComment" color="#D3172E">
                            发送
                        </van-button>
                    </div>
                </div>
            </div>
        </div>

        <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
            <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="" />
            <div class="share-img">
                <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="" />
            </div>
            <div class="share-cancel-btn" @click="showShareDialog = false">
                <img src="/static/img/course/icon_course_share_close.svg" alt="" />
            </div>
        </van-dialog>

        <van-action-sheet v-model="showDownload" title="资料下载">
            <div class="download-cell">
                <van-cell
                    title-class="download-cell__item"
                    v-for="item in course.downloads"
                    :key="item.link"
                    :title="item.name"
                    :url="item.link"
                    :icon="item.type == 'pdf' ? '/static/img/course/icon_course_download_pdf.svg' : '/static/img/course/icon_course_download_pic.svg'"
                    icon-size="20px"
                >
                    <template slot="right-icon">
                        <van-icon name="/static/img/course/icon_course_download.svg" />
                    </template>
                </van-cell>
            </div>
            <div class="van-action-sheet__footer" style="height: 30px">
                <div class="van-action-sheet__gap"></div>
            </div>
        </van-action-sheet>

        <van-dialog class="content" v-model="needPassword" :show-confirm-button="false">
            <template slot="title">
                本视频需要您输入观看密码
            </template>
            <div class="cancel_otp_code_box">
                <div class="otpInputs">
                    <input v-enterfocus ref="otpInputs" type="number" value="12" v-model="code" @keydown.delete="changeCode" />
                    <span class="code_list">{{ code1 }}</span>
                    <span class="code_list">{{ code2 }}</span>
                    <span class="code_list">{{ code3 }}</span>
                    <span class="code_list last_code_list">{{ code4 }}</span>
                </div>
                <p class="error_text" :class="{ show: error }">
                    密码错误请重试
                </p>
            </div>
            <div class="content-footer">
                <van-button style="width: 50%" type="danger" round @click="checkPassword(3)" color="#D3172E">
                    点击验证
                </van-button>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import videojs from 'video.js'
import columnSkeleton from '@/skeleton/columnSkeleton'
import verify from '../../../mixins/verify'
export default {
    name: 'course-detail',
    mixins: [verify],
    components: {
        'column-skeleton': columnSkeleton
    },
    data() {
        return {
            id: '',
            course: {},
            comment: [],
            downloads: [],
            related: [],
            value: '',
            active: '',
            tab: 0,
            comment_text: '',
            course_img_visible: true,
            loading: true,
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            showDownload: false,
            myPlayer: '',
            comment_id: 0,
            to_user_id: 0,
            comment_placeholder: '写评论',
            user_id: 0,
            content_type: 0,
            Duration: 0
        }
    },
    methods: {
        fetch(scene) {
            if (scene === 'course') {
                Interface.getData('get', Interface.short_video.detail + '/' + this.id).then(res => {
                    this.course = res.data
                    this.course.course_time = new Date(this.course.created_at.replace(/-/g, '\/'))
                    document.title = this.course.title
                    if (this.course) {
                        if (this.course.need_password === 1 && !this.course.isPasswordAuth) {
                            this.needPassword = true
                        }
                        Interface.getShareInfo(this, this.course.title, this.course.cover_img, '')
                    }
                    Interface.getData('get', Interface.video_info + '/' + res.data.video_id).then(resp => {
                        let videoUrl

                        this.Duration = Math.ceil(resp.data.VideoBase.Duration / 60)

                        resp.data.PlayInfoList.PlayInfo.forEach(val => {
                            if (val.Format == 'mp4') {
                                videoUrl = val.PlayURL
                            }
                        })
                        const myPlayerOptions = {
                            bigPlayButton: true,
                            textTrackDisplay: true,
                            posterImage: true,
                            errorDisplay: true,
                            controlBar: true,
                            autoplay: false,
                            controls: true
                        }
                        this.course_img_visible = false
                        setTimeout(() => {
                            let _this = this
                            this.myPlayer = videojs('my-video', myPlayerOptions, function onPlayerReady() {
                                this.on('play', function() {
                                    //检测登录
                                    if (_this.course.need_auth === 1) {
                                        let user = localStorage.getItem('user')
                                        user = JSON.parse(user)
                                        if (user.is_complete !== 1) {
                                            this.pause()
                                            _this.$dialog
                                                .confirm({
                                                    title: '需要登录',
                                                    message: '为了方便学习课程,需要您登录认证',
                                                    confirmButtonText: '去认证'
                                                })
                                                .then(() => {
                                                    sessionStorage.setItem('back-url', _this.$route.path)
                                                    _this.$router.push({
                                                        name: 'login'
                                                    })
                                                })
                                        }
                                    }
                                })
                            })
                            this.myPlayer.src(videoUrl)
                            this.myPlayer.load(videoUrl)
                            setTimeout(() => {
                                this.loading = false
                            }, 500)
                        }, 500)
                    })
                    if (this.course.downloads != null && this.course.downloads.length > 0) {
                        this.course.downloads.forEach(item => {
                            if (item.link) {
                                item.type = item.link.substr(item.link.length - 3, 3)
                            }
                        })
                    } else {
                        this.course.downloads = []
                    }
                })
            } else if (scene === 'comment') {
                let params = {
                    content_id: this.id,
                    comment_type: 3,
                    content_type: this.content_type,
                    page: 1,
                    pageSize: 999
                }
                Interface.getData('get', Interface.course.comment.list, params).then(res => {
                    if (res.code == 0 && res.data.list != null) {
                        this.comment = res.data.list
                    }
                })
            } else if (scene === 'share') {
                let params = {
                    content_id: this.id,
                    type: 3
                }
                Interface.getData('get', Interface.share, params).then(res => {
                    this.share_data = res.data
                    this.htmlUrl = res.data.post_img_url
                })
            }
        },
        reComment(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.id
        },
        reCommentChild(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.comment_id
            this.to_user_id = item.user_id
        },
        favorite() {
            let params = {
                content_type: this.content_type
            }
            Interface.getData('get', Interface.short_video.favorite + this.id, params).then(res => {
                if (res.code == 0) {
                    this.course.isFavorite = !this.course.isFavorite
                }
            })
        },
        goComment() {
            this.tab = 1
        },
        createComment() {
            this.tab = 1
            if (this.comment_text == '') {
                return
            }
            if (!Interface.checkComplete(this)){
                return;
            }
            let params = {
                content_id: this.id,
                comment_type: 3,
                content: this.comment_text,
                content_type: this.content_type
            }
            if (this.comment_id != 0) {
                params.comment_id = +this.comment_id
            }
            if (this.to_user_id != 0) {
                params.to_user_id = +this.to_user_id
            }
            Interface.getData('post', Interface.comment, params).then(res => {
                if (res.code == 0) {
                    this.$toast.success('评论成功')
                    this.comment_text = ''
                    this.comment_placeholder = '写评论'
                    this.comment_id = 0
                    this.to_user_id = 0
                    this.fetch('comment')
                    this.goComment()
                }
            })
        },
        pointLikeComment(item) {
            Interface.getData('get', Interface.pointLikeComment + item.id).then(res => {
                if (res.code == 0) {
                    item.isLike = !item.isLike
                    if (item.isLike) {
                        item.like_count += 1
                    } else {
                        item.like_count -= 1
                    }
                }
            })
        },
        pointLike() {
            Interface.getData('get', Interface.short_video.point_like + this.id).then(res => {
                if (res.code == 0) {
                    this.course.isLike = !this.course.isLike
                    if (this.course.isLike) {
                        this.course.like_count += 1
                    } else {
                        this.course.like_count -= 1
                    }
                }
            })
        },
        openShareData() {
            this.showShareDialog = true
        }
    },
    created() {
        this.id = this.$route.params.id
        if (this.$route.query.content_type) {
            this.content_type = this.$route.query.content_type
        }
        this.fetch('course')
        this.fetch('comment')
        this.fetch('share')
        Interface.footPrint(3, this.id, this.content_type)
    },
    watch: {
        async $route(to, from) {
            this.loading = true
            this.id = this.$route.params.id
            window.location.reload()
        }
    },
    destroyed() {
        if (this.myPlayer) {
            this.myPlayer.dispose()
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/video/detail/index.vue